<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -5em;">
      <b-row class="mt-3 justify-content-center">
        <b-col cols="8">
          <div v-if="!loading" class="sg-rounded-container p-4 mx-3">
            <PriceDetail :payment="payment" :price_detail="price_detail" :total_detail="total_detail" />
          </div>
          <br>
          <div v-if="!loading" class="sg-rounded-container p-4 mx-3">
            <b-row class="center-base between px-3">
              <b-col cols="2" class="p-0 center-base all">
                <span style="font-size: 18px;">Promo Code</span>
              </b-col>
              <b-col cols="5" class="p-0">
                <b-col cols="12" lg="12">
                  <b-input-group
                    label="Promo Code"
                    label-for="input-promo-code"
                    label-sr-only
                  >
                    <b-form-input
                      id="input-promo-code"
                      placeholder="Promo Code"
                      v-model="promo.code"
                      :disabled="promo_button"
                      type="text"
                    />
                  </b-input-group>
                </b-col>
              </b-col>
              <b-col cols="4" class="p-0 text-right">
                <b-row>
                  <b-col>
                    <b-button block variant="success" size="md" @click="usePromo" class="sg-box-shadow" :disabled="promo_button">
                      Submit
                    </b-button>

                  </b-col>
                  <b-col class="pl-0">
                    <b-button block variant="outline-danger" size="md" @click="cancelPromo" class="sg-box-shadow">
                      Cancel
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <div v-else class="sg-rounded-container center-base all">
            <b-spinner variant="primary" type="grow" label="Spinning" />
          </div>

          <div v-if="!loading" class="px-4 mx-3">
            <b-row class="mt-4 mx-4">
              <b-col class="p-0">
                <b-form-checkbox id='input-agreement' v-model="agreement">
                  <i style="font-size: 12px;">
                    By clicking the button below, you agree to
                    <router-link :to="{ name: 'TermsAndCondition' }" style="color: #f27137; font-weight: 400;">StarGuides's Terms & Condition</router-link>
                    and that you have read our
                    <router-link :to="{ name: 'PrivacyAndPolicy' }" style="color: #f27137; font-weight: 400;">Data Use Policy</router-link>
                    , including our
                    <router-link :to="{ name: 'PrivacyAndPolicy' }" style="color: #f27137; font-weight: 400;">Cookie Policy</router-link>.
                    </i>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row class="justify-content-center mt-3">
              <b-col cols="4">
                <b-button block variant="success" size="lg" @click="doPayment('transfer')" class="sg-box-shadow" :disabled="pay_button_state">
                  Pay
                </b-button>
              </b-col>
              <b-col cols="4">
                <b-button block variant="outline-success" size="lg" @click="doPayment('snap')" class="sg-box-shadow" :disabled="pay_button_state">
                  Pay with GoPay
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col cols="4" v-if="payment_data.type_of_order === 'order'">
          <div class="sg-rounded-container p-4 mx-3">
            <OrderSummary :tgbs_order_id="payment.tgbs_order_id" />
          </div>
        </b-col>

        <b-col cols="4" v-else>
          <div class="sg-rounded-container p-4 mx-3">
            <b-row>
              <b-col>
                <h6>Registration Fee</h6>
              </b-col>
            </b-row>

            <hr style="border-top: 2px solid #dddddd;">

            <b-row>
              <b-col>
                <span>Guider registration, included StarGuides's Scarf</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-5" />
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -2em;">
      <b-row>
        <b-col>
          <div v-if="!loading" class="sg-rounded-container p-4 mx-3">
            <PriceDetail :payment="payment" :price_detail="price_detail" :total_detail="total_detail" />
          </div>

          <div v-else class="sg-rounded-container center-base all">
            <b-spinner variant="primary" type="grow" label="Spinning" />
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col v-if="payment_data.type_of_order === 'order'">
          <div class="sg-rounded-container p-4 mx-3">
            <OrderSummary :tgbs_order_id="payment.tgbs_order_id" />
          </div>
        </b-col>

        <b-col v-else>
          <div class="sg-rounded-container p-4 mx-3">
            <b-row>
              <b-col>
                <h6>Registration Fee</h6>
              </b-col>
            </b-row>

            <hr style="border-top: 2px solid #dddddd;">

            <b-row>
              <b-col>
                <span>Guider registration, included StarGuides's Scarf</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <div v-if="!loading" class="px-1 mx-1">
            <b-row class="mt-2 mx-2">
              <b-col class="p-0">
                <b-form-checkbox id='input-agreement' v-model="agreement">
                  <i style="font-size: 12px;">
                    By clicking the button below, you agree to
                    <router-link :to="{ name: 'TermsAndCondition' }" style="color: #f27137; font-weight: 400;">StarGuides's Terms & Condition</router-link>
                    and that you have read our
                    <router-link :to="{ name: 'PrivacyAndPolicy' }" style="color: #f27137; font-weight: 400;">Data Use Policy</router-link>
                    , including our
                    <router-link :to="{ name: 'PrivacyAndPolicy' }" style="color: #f27137; font-weight: 400;">Cookie Policy</router-link>.
                    </i>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3 justify-content-center">
        <b-col cols="10">
          <b-button block variant="success" size="md" @click="doPayment('transfer')" class="sg-box-shadow" :disabled="pay_button_state">
            Pay
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-center">
        <b-col cols="10">
          <b-button block variant="outline-success" size="md" @click="doPayment('snap')" class="sg-box-shadow" :disabled="pay_button_state">
            Pay with GoPay
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3" />
    </b-container>
  </div>
</template>

<script>
// external dependencies
// import snap from 'snap'
import swal from 'sweetalert'
import VueJwtDecode from 'vue-jwt-decode'

// custom component
import Jumbotron from '@/components/Jumbotron'
import OrderSummary from '@/components/Pay/OrderSummary'
import PriceDetail from '@/components/Pay/PriceDetail'

// api call
import PromoCodeAPI from '@/api/PromoCodeAPI'
import PaymentAPI from '@/api/PaymentAPI'
import AuthenticationAPI from '@/api/AuthenticationAPI'

export default {
  name: 'Pay_Now',
  components: {
    Jumbotron,
    OrderSummary,
    PriceDetail
  },
  data () {
    return {
      payment: {
        sg_user_id: this.user_id,
        tgbs_order_id: this.payment_data.tgbs_order_id,
        order_id: this.payment_data.order_id,
        type_of_user: this.payment_data.type_of_user,
        type_of_order: this.payment_data.type_of_order,

        items: this.payment_data.items,

        currency: 'EUR',
        promo_id: null,
        promo: 0,
        subtotal: 0,
        additional: 0,
        total: 0,
        totalIDR: 0,
        grandTotalIDR: 0
      },

      promo: {
        code: null,
        name: null
      },
      price_detail: [],
      total_detail: {},

      exchangeRate: 0,
      agreement: false,

      loading: true,
      promo_button: false,
      pay_button_state: false, // if use core API: true
      errors: []
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user_id = decode._id

      this.payment_data = this.$cookies.get('payment_data')
    } else {
      this.user_id = null
    }
  },
  created: function () {
    if (this.isEmpty(this.payment_data)) this.$router.push({ name: 'PageNotFound' })
    else this.countTotalPrice()
  },
  methods: {
    // PREREQUISITES
    isEmpty: function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
      }
      return true
    },
    toMoney: function (int) {
      if (int) return int.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    },
    countTotalPricePromo: function (price, promo) {
      this.loading = true

      this.getCurrentEuro().then(() => {
        // COUNT SUBTOTAL
        if (this.promo_button) {
          this.payment.grandTotalIDR = parseInt(price.total_payment * this.exchangeRate)
          this.payment.subtotalIDR = parseInt(price.payment * this.exchangeRate)
          if (price.promoIDR) {
            this.payment.promoIDR = parseInt(price.promoIDR)
            this.payment.total = parseInt(price.payment + this.payment.additional)
            this.payment.totalIDR = parseInt(this.payment.total * this.exchangeRate) - this.payment.promoIDR
          } else {
            this.payment.promoIDR = parseInt(price.promo * this.exchangeRate)
            this.payment.total = parseInt(price.payment + this.payment.additional)
            this.payment.totalIDR = parseInt(this.payment.total * this.exchangeRate)
          }
          this.price_detail.push({ label: `Promo #${promo.promo_name}`, currency: 'IDR', amountIDR: this.toMoney(this.payment.promoIDR), amountEUR: this.toMoney(this.payment.promo) })
          this.total_detail = {
            label: 'Total',
            currency: 'IDR',
            amountIDR: this.toMoney(this.payment.totalIDR),
            amountEUR: this.toMoney(this.payment.total)
          }
        }
        this.loading = false
      })
    },
    countTotalPrice: function () {
      this.loading = true

      this.getCurrentEuro().then(() => {
        this.payment.items.forEach((item, index) => {
          this.payment.subtotal += parseInt(item.price * item.qty)
          this.payment.subtotalIDR = this.payment.subtotal * this.exchangeRate
          this.payment.items[index].priceIDR = item.price * this.exchangeRate
        })
        // COUNT TOTAL
        this.payment.total = this.payment.subtotal + this.payment.additional
        this.payment.totalIDR = this.payment.total * this.exchangeRate
        // ini pakai object yg baru, pakai array, design yg baru dr ui/ux
        // setelah perubahan ini: perlu simpan semua variable penghitungan?
        // supaya lebih rinci dan sama seperti yg dimunculin di awal aja sih
        this.price_detail.push({ label: 'Sub Total', currency: 'IDR', amountIDR: this.toMoney(this.payment.subtotalIDR), amountEUR: this.toMoney(this.payment.subtotal) })
        this.price_detail.push({ label: 'Additional', currency: 'IDR', amountIDR: this.toMoney(0), amountEUR: this.toMoney(0) })
        this.total_detail = {
          label: 'Total',
          currency: 'IDR',
          amountIDR: this.toMoney(this.payment.totalIDR),
          amountEUR: this.toMoney(this.payment.total)
        }

        this.loading = false
      })
    },
    doPayment: function (by) {
      this.pay_button_state = true

      if (by === 'transfer') {
        // pembayaran dengan transfer manual
        this.payTransfer()
      } else if (by === 'snap') {
        // pembayaran dengan cc via Snap
        // this.paySnap()
      }
    },
    usePromo: async function () {
      let data = {
        promo: this.promo,
        service: this.payment.items[0],
        type_of_order: this.payment.type_of_order,
        tgbs_order_id: this.payment.tgbs_order_id
      }
      try {
        let promocode = await PromoCodeAPI.usePromo(data)
        this.promo_button = false
        if (promocode.data.promo && promocode.data.icon === `success`) {
          this.promo_button = true
          this.payment.promo_id = promocode.data.promo._id
          this.payment.promo = promocode.data.price.promo

          this.countTotalPricePromo(promocode.data.price, promocode.data.promo)
        }
        swal({
          title: promocode.data.msg,
          icon: promocode.data.icon,
          button: {
            text: 'Ok'
          }
        })
      } catch (error) {
        let msg = error.response.data
        swal({
          title: `There's an error`,
          text: msg,
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })
        this.promo_button = false
      }
    },
    cancelPromo: function () {
      if (this.promo_button === true) {
        this.promo_button = false
        this.promo.code = null
        this.promo.name = null
        this.payment.promo_id = null
        this.payment.subtotal = 0
        this.payment.promo = 0
        this.price_detail = []
        this.total_detail = {}
        this.countTotalPrice()
      }
    },
    // END PREREQUISITES

    // HTTP REQUEST
    getCurrentEuro: async function () {
      return new Promise((resolve) => {
        PaymentAPI.getCurrentEuro().then((response) => {
          this.exchangeRate = parseInt(response.data.rate.value)
          this.payment.euridrrate = this.exchangeRate

          resolve()
        })
      })
    },
    updateSessionData: async function (params) {
      // UNTUK GANTI STATUS GUIDER, yg udah ada di session

      return new Promise((resolve) => {
        AuthenticationAPI.updateSessionData(params).then((response) => {
          if (response.data.token) this.$session.set(`jwt`, response.data.token)
          resolve()
        })
      })
    },
    // paySnap: async function () {
    //   let self = this

    //   if (!self.agreement) {
    //     swal({
    //       title: 'Please check, that you agreed with our Terms & Condition and Privacy Policy',
    //       icon: 'error',
    //       button: {
    //         text: 'Ok'
    //       }
    //     })
    //     this.pay_button_state = false
    //   } else {
    //     try {
    //       const response = await PaymentAPI.paySnap(self.payment)

    //       // SnapToken acquired from previous step
    //       snap.pay(response.data.transactionToken, {
    //         onSuccess: function (params) {
    //           if (self.payment.type_of_order === 'registration') params.postPaymentApi = 'postPaymentRegistration'
    //           if (self.payment.type_of_order === 'order') {
    //             params.postPaymentApi = 'postPaymentOrder'
    //             params.tgbs_order_id = self.payment_data.tgbs_order_id
    //           }

    //           params.sg_user_id = self.user_id
    //           params.status = 'paid'

    //           self.postSnapPayment(params).then(() => {
    //             self.updateSessionData({ sg_user_id: params.sg_user_id }).then(() => {
    //               self.$cookies.remove('payment_data')

    //               // redirect to thank you page
    //               self.$router.push({
    //                 name: 'Pay_Success',
    //                 params
    //               })
    //             })
    //           })
    //         },
    //         onPending: function (params) {
    //           if (self.payment.type_of_order === 'registration') params.postPaymentApi = 'postPaymentRegistration'
    //           if (self.payment.type_of_order === 'order') {
    //             params.postPaymentApi = 'postPaymentOrder'
    //             params.tgbs_order_id = self.payment_data.tgbs_order_id
    //           }

    //           params.sg_user_id = self.user_id
    //           params.status = 'pending'

    //           self.postSnapPayment(params).then(() => {
    //             self.$cookies.remove('payment_data')

    //             // redirect to pending page
    //             self.$router.push({
    //               name: 'Pay_Pending',
    //               params
    //             })
    //           })
    //         },
    //         onError: function (params) {
    //           self.$router.push({
    //             name: 'Pay_Failed',
    //             params
    //           })
    //         }
    //       })
    //     } catch (error) {
    //       swal({
    //         title: 'We\'re sorry we couldn\'t process the payment. Please try again later.',
    //         icon: 'error',
    //         button: {
    //           text: 'Ok'
    //         }
    //       })

    //       this.pay_button_state = false
    //     }
    //   }
    // },
    // postSnapPayment: async function (params) {
    //   return new Promise((resolve) => {
    //     PaymentAPI.postSnapPayment(params).then(() => {
    //       resolve()
    //     })
    //   })
    // },
    payTransfer: async function () {
      if (!this.agreement) {
        swal({
          title: 'Please check, that you agreed with our Terms & Condition and Privacy Policy',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.pay_button_state = false
      } else {
        // create payment dg status 'payment_customer' -> untuk dapat payment ID
        // kirim payment_id ke pending + kirim email
        // push route ke Pay_Pending

        let params = this.payment
        params.status = 'pending_customer'
        params.payment_type = 'manual_transfer'

        if (this.payment.type_of_order === 'registration') params.postPaymentApi = 'postPaymentRegistration'
        if (this.payment.type_of_order === 'order') params.postPaymentApi = 'postPaymentOrder'

        try {
          const response = await PaymentAPI.paymentOrderBankTrf(params)

          this.$cookies.remove('order_data')
          this.$cookies.remove('payment_data')

          this.$router.push({
            name: 'Pay_Pending',
            params: response.data.payment
          })
        } catch (error) {
          swal({
            title: 'We\'re sorry we couldn\'t process the payment. Please try again later.',
            icon: 'error',
            button: {
              text: 'Ok'
            }
          })
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Pay/Now.vue